/*!
 * The MIT License (MIT)
 * 
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * @version 2.0.8
 */
(function(ns) {'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @external {Object.assign} https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */
/* istanbul ignore next */
if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(target, firstSource) {
            'use strict';

            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert first argument to object');
            }

            var to = Object(target);
            var i = 1;

            for (; i < arguments.length; i++) {
                var nextSource = arguments[i];

                if (nextSource === undefined || nextSource === null) {
                    continue;
                }

                var keysArray = Object.keys(Object(nextSource));
                var nextIndex = 0,
                    len = keysArray.length;

                for (; nextIndex < len; nextIndex++) {
                    var nextKey = keysArray[nextIndex];
                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

                    if (desc !== undefined && desc.enumerable) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }

            return to;
        }
    });
}

/**
 * @external {Array.indexOf} https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
 */
/* istanbul ignore next */
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
        var k;

        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }

        var O = Object(this);
        var len = O.length >>> 0;

        if (len === 0) {
            return -1;
        }

        var n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        if (n >= len) {
            return -1;
        }

        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        while (k < len) {
            if (k in O && O[k] === searchElement) {
                return k;
            }

            k++;
        }

        return -1;
    };
}

/**
 * @external {Array.fill} https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
 */
/* istanbul ignore next */
if (!Array.prototype.fill) {
    Array.prototype.fill = function (value) {
        if (this == null) {
            throw new TypeError('this is null or not defined');
        }

        var O = Object(this);
        var len = O.length >>> 0;
        var start = arguments[1];
        var relativeStart = start >> 0;
        var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
        var end = arguments[2];
        var relativeEnd = end === undefined ? len : end >> 0;
        var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
        while (k < final) {
            O[k] = value;
            k++;
        }

        return O;
    };
}

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/**
 * Look-ups for a proper vendor-specific property and returns its value
 *
 * @example
 * var requestAnimationFrame = vendorize('requestAnimationFrame');
 * // it will refer properly to:
 * //  - window.requestAnimationFrame by default or to
 * //  - window.webkitRequestAnimationFrame or to
 * //  - window.mozRequestAnimationFrame or to
 * //  - window.msRequestAnimationFrame or to
 * //  - window.oRequestAnimationFrame
 * // depending on the current browser vendor
 *
 * @author Mykhailo Stadnyk <mikhus@gmail.com>
 * @param {string} prop
 * @param {HTMLElement|Window|object} [from] - default is window
 * @returns {*}
 */
function vendorize(prop, from) {
    /* istanbul ignore else: no reason to cover */
    if (!from) {
        from = typeof window === 'undefined' ? global : window;
    }

    if (typeof from[prop] !== 'undefined') {
        return from[prop];
    }

    var vendors = ['webkit', 'moz', 'ms', 'o'];
    var i = 0;
    var s = vendors.length;
    var capitalized = prop.charAt(0).toUpperCase() + prop.substr(1);

    for (; i < s; i++) {
        var vendorProp = from[vendors[i] + capitalized];

        /* istanbul ignore if: requires very complex environment to test (specific browser version) */
        if (typeof vendorProp !== 'undefined') {
            return vendorProp;
        }
    }

    return null;
}

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * @ignore
 * @typedef {object} ns
 */

/* istanbul ignore next */
/**
 * @type {function(callback: function(time: number): number, element?: HTMLElement)}
 * @access private
 */
var requestAnimationFrame = vendorize('requestAnimationFrame') || function (callback) {
    return setTimeout(function () {
        return callback(new Date().getTime());
    }, 1000 / 60);
};

/**
 * Generic AnimationRule function interface
 *
 * @typedef {function(percent: number): number} AnimationRule
 */

/**
 * Callback for animation step draw event.
 * It will be called each time animation step is executed, bypassing
 * as first argument a percent of animation completeness. It is expected
 * that this callback will do an actual work of animating an elements or
 * whatever, as far as animation engine is just calculating and executing
 * animation steps without any knowledge about things under animation.
 *
 * @typedef {function(percent: number): *} DrawEventCallback
 */

/**
 * Callback for animation complete event.
 * It is called once each animation is complete.
 *
 * @typedef {function(): *} EndEventCallback
 */

/**
 * Predefined known animation rules.
 * It's a simple collection of math for some most used animations.
 *
 * @typedef {{linear: AnimationRule, quad: AnimationRule, dequad: AnimationRule, quint: AnimationRule, dequint: AnimationRule, cycle: AnimationRule, decycle: AnimationRule, bounce: AnimationRule, debounce: AnimationRule, elastic: AnimationRule, delastic: AnimationRule}} AnimationRules
 */

/* istanbul ignore next: no reason covering this */
var rules = {
    linear: function linear(p) {
        return p;
    },
    quad: function quad(p) {
        return Math.pow(p, 2);
    },
    dequad: function dequad(p) {
        return 1 - rules.quad(1 - p);
    },
    quint: function quint(p) {
        return Math.pow(p, 5);
    },
    dequint: function dequint(p) {
        return 1 - Math.pow(1 - p, 5);
    },
    cycle: function cycle(p) {
        return 1 - Math.sin(Math.acos(p));
    },
    decycle: function decycle(p) {
        return Math.sin(Math.acos(1 - p));
    },
    bounce: function bounce(p) {
        return 1 - rules.debounce(1 - p);
    },
    debounce: function debounce(p) {
        var a = 0,
            b = 1;
        for (; 1; a += b, b /= 2) {
            if (p >= (7 - 4 * a) / 11) {
                return -Math.pow((11 - 6 * a - 11 * p) / 4, 2) + Math.pow(b, 2);
            }
        }
    },
    elastic: function elastic(p) {
        return 1 - rules.delastic(1 - p);
    },
    delastic: function delastic(p) {
        var x = 1.5;
        return Math.pow(2, 10 * (p - 1)) * Math.cos(20 * Math.PI * x / 3 * p);
    }
};

/* istanbul ignore next: private, not testable */
/**
 * Evaluates animation step and decides if the next step required or
 * stops animation calling a proper events.
 *
 * @access private
 * @param {number} time
 * @param {DrawEventCallback} draw
 * @param {number} start
 * @param {AnimationRule} rule
 * @param {number} duration
 * @param {EndEventCallback} end
 * @param {Animation} anim
 */
function step(time, draw, start, rule, duration, end, anim) {
    if (typeof rule !== 'function') {
        throw new TypeError('Invalid animation rule:', rule);
    }

    var progress = time - start;
    var percent = progress / duration;

    if (percent > 1) {
        percent = 1;
    }

    draw && draw(percent === 1 ? percent : rule(percent));

    if (progress < duration) {
        anim.frame = requestAnimationFrame(function (time) {
            return step(time, draw, start, rule, duration, end, anim);
        });
    } else {
        end && end();
    }
}

/**
 * Animation engine API for JavaScript-based animations.
 * This is simply an animation core framework which simplifies creation
 * of various animations for generic purposes.
 *
 * @example
 * // create 'linear' animation engine, 500ms duration
 * let linear = new Animation('linear', 500);
 *
 * // create 'elastic' animation engine
 * let elastic = new Animation('elastic');
 *
 * // define animation behavior
 * let bounced = new Animation('bounce', 500, percent => {
 *     let value = parseInt(percent * 100, 10);
 *
 *     $('div.bounced').css({
 *         width: value + '%',
 *         height: value + '%'
 *     });
 * });
 *
 * // execute animation
 * bounced.animate();
 *
 * // execute animation and handle when its finished
 * bounced.animate(null, () => {
 *    console.log('Animation finished!');
 * });
 */

var Animation = function () {

    /**
     * @constructor
     * @param {string|AnimationRule} rule
     * @param {number} duration
     * @param {DrawEventCallback} [draw]
     * @param {EndEventCallback} [end]
     */
    function Animation() {
        var rule = arguments.length <= 0 || arguments[0] === undefined ? 'linear' : arguments[0];
        var duration = arguments.length <= 1 || arguments[1] === undefined ? 250 : arguments[1];
        var draw = arguments.length <= 2 || arguments[2] === undefined ? function () {} : arguments[2];
        var end = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];

        _classCallCheck(this, Animation);

        /**
         * Overall animation duration in milliseconds.
         * By default is equal to 250 ms.
         *
         * @type {number}
         */
        this.duration = duration;

        /**
         * Animation rule. By default is linear animation.
         * Animation rule is a subject to animation rules, which are
         * a simple object containing math-based methods for calculating
         * animation steps.
         *
         * @type {string|AnimationRule}
         */
        this.rule = rule;

        /**
         * Callback function for the animation step draw event.
         *
         * @type {DrawEventCallback}
         */
        this.draw = draw;

        /**
         * Callback for the animation complete event.
         *
         * @type {EndEventCallback}
         */
        this.end = end;

        if (typeof this.draw !== 'function') {
            throw new TypeError('Invalid animation draw callback:', draw);
        }

        if (typeof this.end !== 'function') {
            throw new TypeError('Invalid animation end callback:', end);
        }
    }

    /* istanbul ignore next: non-testable */
    /**
     * Performs animation calling each animation step draw callback and
     * end callback at the end of animation. Callbacks are optional to this
     * method call. If them are not bypassed will be used that ones which
     * was pre-set on constructing an Animation object or pre-set after
     * construction.
     *
     * @example
     * function draw(percent) {
     *     $('.my-animated-divs').css({
     *         width: parseInt(percent * 100, 10) + '%'
     *     });
     * }
     * function done() {
     *     console.log('Animation complete!');
     * }
     *
     * // Define 'draw' and 'end' callbacks on construction
     * var animation = new Animation('cycle', 500, draw, done);
     * animation.animate();
     *
     * // Define 'draw' and 'end' callbacks after construction
     * var animation = new Animation('cycle', 500);
     * animation.draw = draw;
     * animation.end = done;
     * animation.animate();
     *
     * // Define 'draw' and 'end' callbacks at animation
     * var animation = new Animation('cycle', 500);
     * animation.animate(draw, done);
     *
     * @param {DrawEventCallback} [draw]
     * @param {EndEventCallback} [end]
     */


    _createClass(Animation, [{
        key: 'animate',
        value: function animate(draw, end) {
            var _this = this;

            //noinspection JSUnresolvedVariable
            var start = ns.performance && ns.performance.now ? ns.performance.now() : vendorize('animationStartTime') || Date.now();

            draw = draw || this.draw;
            end = end || this.end;

            /**
             * Current requested animation frame identifier
             *
             * @type {number}
             */
            this.frame = requestAnimationFrame(function (time) {
                return step(time, draw, start, rules[_this.rule] || _this.rule, _this.duration, end, _this);
            });
        }

        /**
         * Destroys this object properly
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.frame) {
                var cancelAnimationFrame = vendorize('cancelAnimationFrame') ||
                /* istanbul ignore next */
                function (id) {};

                cancelAnimationFrame(this.frame);
                this.frame = null;
            }

            this.draw = null;
            this.end = null;
        }
    }]);

    return Animation;
}();

/**
 * Animation rules bound statically to Animation constructor.
 *
 * @type {AnimationRules}
 * @static
 */


Animation.rules = rules;

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/**
 * @typedef {{ constructor: function(options: GenericOptions): GaugeInterface, draw: function(): GaugeInterface, destroy: function, update: function(options: GenericOptions) }} GaugeInterface
 */
/**
 * @typedef {{parse: function, stringify: function}} JSON
 * @external {JSON} https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/JSON
 */
/**
 * @ignore
 * @typedef {{MutationObserver: function}} ns
 */

/**
 * DOM Observer.
 * It will observe DOM document for a configured element types and
 * instantiate associated Types for an existing or newly added DOM elements
 *
 * @example
 * class ProgressBar {
 *     constructor(options) {}
 *     draw() {}
 * }
 *
 * // It will observe DOM document for elements <div>
 * // having attribute 'data-type="progress"'
 * // and instantiate for each new instance of ProgressBar
 *
 * new DomParser({color: 'red'}, 'div', 'progress', ProgressBar);
 *
 * // assume we could have HTML like this
 * // <div data-type="progress" color="blue"></div>
 * // in this case all matching attributes names for a given options will be
 * // parsed and bypassed to an instance from HTML attributes
 */

var DomObserver = function () {

    /**
     * @constructor
     * @param {object} options
     * @param {string} element
     * @param {string} type
     */
    function DomObserver(options, element, type) {
        _classCallCheck(this, DomObserver);

        //noinspection JSUnresolvedVariable
        /**
         * Default instantiation options for the given type
         *
         * @type {Object}
         */
        this.options = options;

        /**
         * Name of an element to lookup/observe
         *
         * @type {string}
         */
        this.element = element.toLowerCase();

        /**
         * data-type attribute value to lookup
         *
         * @type {string}
         */
        this.type = DomObserver.toDashed(type);

        /**
         * Actual type constructor to instantiate for each found element
         *
         * @type {Function}
         */
        this.Type = ns[type];

        /**
         * Signals if mutations observer for this type or not
         *
         * @type {boolean}
         */
        this.mutationsObserved = false;

        /**
         * Flag specifies whenever the browser supports observing
         * of DOM tree mutations or not
         *
         * @type {boolean}
         */
        this.isObservable = !!ns.MutationObserver;

        /* istanbul ignore next: this should be tested with end-to-end tests */
        DomObserver.domReady(this.traverse.bind(this));
    }

    /**
     * Checks if given node is valid node to process
     *
     * @param {Node|HTMLElement} node
     * @returns {boolean}
     */


    _createClass(DomObserver, [{
        key: 'isValidNode',
        value: function isValidNode(node) {
            //noinspection JSUnresolvedVariable
            return !!(node.tagName && node.tagName.toLowerCase() === this.element && node.getAttribute('data-type') === this.type);
        }

        /**
         * Traverse entire current DOM tree and process matching nodes.
         * Usually it should be called only once on document initialization.
         */

    }, {
        key: 'traverse',
        value: function traverse() {
            var elements = document.getElementsByTagName(this.element);
            var i = 0,
                s = elements.length;

            /* istanbul ignore next: this should be tested with end-to-end tests */
            for (; i < s; i++) {
                this.process(elements[i]);
            }

            if (this.isObservable && !this.mutationsObserved) {
                new ns.MutationObserver(this.observe.bind(this)).observe(document.body, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true,
                    attributeOldValue: true,
                    characterDataOldValue: true
                });

                this.mutationsObserved = true;
            }
        }

        /**
         * Observes given mutation records for an elements to process
         *
         * @param {MutationRecord[]} records
         */

    }, {
        key: 'observe',
        value: function observe(records) {
            var _this2 = this;

            var i = 0;
            var s = records.length;

            /* istanbul ignore next: this should be tested with end-to-end tests */

            var _loop = function _loop() {
                var record = records[i];

                if (record.type === 'attributes' && record.attributeName === 'data-type' && _this2.isValidNode(record.target) && record.oldValue !== _this2.type) // skip false-positive mutations
                    {
                        setTimeout(function () {
                            return _this2.process(record.target);
                        });
                    } else if (record.addedNodes && record.addedNodes.length) {
                    var ii = 0;
                    var ss = record.addedNodes.length;

                    for (; ii < ss; ii++) {
                        _this2.process(record.addedNodes[ii]);
                    }
                }
            };

            for (; i < s; i++) {
                _loop();
            }
        }

        /**
         * Parses given attribute value to a proper JavaScript value.
         * For example it will parse some stringified value to a proper type
         * value, e.g. 'true' => true, 'null' => null, '{"prop": 20}' => {prop: 20}
         *
         * @param {*} value
         * @return {*}
         */

    }, {
        key: 'process',


        /**
         * Processes a given node, instantiating a proper type constructor for it
         *
         * @param {Node|HTMLElement} node
         * @returns {GaugeInterface|null}
         */
        value: function process(node) {
            var _this3 = this;

            if (!this.isValidNode(node)) return null;

            var prop = void 0;
            var options = JSON.parse(JSON.stringify(this.options));
            var instance = null;

            for (prop in options) {
                /* istanbul ignore else: non-testable in most cases */
                if (options.hasOwnProperty(prop)) {
                    var attributeName = DomObserver.toAttributeName(prop);
                    var attributeValue = DomObserver.parse(node.getAttribute(attributeName));

                    if (attributeValue !== null && attributeValue !== undefined) {
                        options[prop] = attributeValue;
                    }
                }
            }

            options.renderTo = node;
            instance = new this.Type(options);
            instance.draw && instance.draw();

            if (!this.isObservable) return instance;

            instance.observer = new ns.MutationObserver(function (records) {
                records.forEach(function (record) {
                    if (record.type === 'attributes') {
                        var attr = record.attributeName.toLowerCase();
                        var type = node.getAttribute(attr).toLowerCase();

                        if (attr === 'data-type' && type && type !== _this3.type) {
                            instance.observer.disconnect();
                            delete instance.observer;
                            instance.destroy && instance.destroy();
                        } else if (attr.substr(0, 5) === 'data-') {
                            var _prop = attr.substr(5).split('-').map(function (part, i) {
                                return !i ? part : part.charAt(0).toUpperCase() + part.substr(1);
                            }).join('');
                            var _options = {};

                            _options[_prop] = DomObserver.parse(node.getAttribute(record.attributeName));

                            instance.update && instance.update(_options);
                        }
                    }
                });
            });

            //noinspection JSCheckFunctionSignatures
            instance.observer.observe(node, { attributes: true });

            return instance;
        }

        /**
         * Transforms camelCase string to dashed string
         *
         * @static
         * @param {string} camelCase
         * @return {string}
         */

    }], [{
        key: 'parse',
        value: function parse(value) {
            // parse boolean
            if (value === 'true') return true;
            if (value === 'false') return false;

            // parse undefined
            if (value === 'undefined') return undefined;

            // parse null
            if (value === 'null') return null;

            // Comma-separated strings to array parsing.
            // It won't match strings which contains non alphanumeric characters to
            // prevent strings like 'rgba(0,0,0,0)' or JSON-like from being parsed.
            // Typically it simply allows easily declare arrays as comma-separated
            // numbers or plain strings. If something more complicated is
            // required it can be declared using JSON format syntax
            if (/^[-+#.\w\d\s]+(?:,[-+#.\w\d\s]*)+$/.test(value)) {
                return value.split(',');
            }

            // parse JSON
            try {
                return JSON.parse(value);
            } catch (e) {}

            // plain value - no need to parse
            return value;
        }
    }, {
        key: 'toDashed',
        value: function toDashed(camelCase) {
            var arr = camelCase.split(/(?=[A-Z])/);
            var i = 1;
            var s = arr.length;
            var str = arr[0].toLowerCase();

            for (; i < s; i++) {
                str += '-' + arr[i].toLowerCase();
            }

            return str;
        }

        /**
         * Transforms camel case property name to dash separated attribute name
         *
         * @static
         * @param {string} str
         * @returns {string}
         */

    }, {
        key: 'toAttributeName',
        value: function toAttributeName(str) {
            return 'data-' + DomObserver.toDashed(str);
        }

        /**
         * Cross-browser DOM ready handler
         *
         * @static
         * @param {Function} handler
         */

    }, {
        key: 'domReady',
        value: function domReady(handler) {
            if (/comp|inter|loaded/.test((ns.document || {}).readyState + '')) return handler();

            if (ns.addEventListener) ns.addEventListener('DOMContentLoaded', handler, false);else if (ns.attachEvent) ns.attachEvent('onload', handler);
        }
    }]);

    return DomObserver;
}();

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * @ignore
 * @typedef {object} ns
 */

/**
 * Drawings on canvas using hidden canvas as a cache for better
 * performance drawings during canvas animations. SmartCanvas also
 * adopts a canvas to
 */


var SmartCanvas = function () {

    /**
     * @constructor
     * @param {HTMLCanvasElement} canvas
     * @param {number} [width]
     * @param {number} [height]
     */
    function SmartCanvas(canvas, width, height) {
        _classCallCheck(this, SmartCanvas);

        SmartCanvas.collection.push(this);

        /**
         * Canvas base width
         *
         * @type {number}
         */
        this.width = width || 0;

        /**
         * Canvas base height
         *
         * @type {number}
         */
        this.height = height || 0;

        /**
         * Target drawings canvas element
         *
         * @type {HTMLCanvasElement}
         */
        this.element = canvas;

        this.init();
    }

    /**
     * Initializes canvases and contexts
     */


    _createClass(SmartCanvas, [{
        key: 'init',
        value: function init() {
            var pixelRatio = SmartCanvas.pixelRatio;

            this.element.width = this.width * pixelRatio;
            this.element.height = this.height * pixelRatio;

            this.element.style.width = this.width + 'px';
            this.element.style.height = this.height + 'px';

            /**
             * Canvas caching element
             *
             * @type {HTMLCanvasElement|Node}
             */
            this.elementClone = this.element.cloneNode(true);

            //noinspection JSUnresolvedVariable
            /**
             * Target drawings canvas element 2D context
             *
             * @type {CanvasRenderingContext2D}
             */
            this.context = this.element.getContext('2d');

            /**
             * Canvas caching element 2D context
             *
             * @type {CanvasRenderingContext2D}
             */
            this.contextClone = this.elementClone.getContext('2d');

            /**
             * Actual drawings width
             *
             * @type {number}
             */
            this.drawWidth = this.element.width;

            /**
             * Actual drawings height
             *
             * @type {number}
             */
            this.drawHeight = this.element.height;

            /**
             * X-coordinate of drawings zero point
             *
             * @type {number}
             */
            this.drawX = this.drawWidth / 2;

            /**
             * Y-coordinate of drawings zero point
             *
             * @type {number}
             */
            this.drawY = this.drawHeight / 2;

            /**
             * Minimal side length in pixels of the drawing
             *
             * @type {number}
             */
            this.minSide = this.drawX < this.drawY ? this.drawX : this.drawY;

            this.elementClone.initialized = false;

            this.contextClone.translate(this.drawX, this.drawY);
            this.contextClone.save();

            this.context.translate(this.drawX, this.drawY);
            this.context.save();

            this.context.max = this.contextClone.max = this.minSide;
            this.context.maxRadius = this.contextClone.maxRadius = null;
        }

        /**
         * Destroys this object, removing the references from memory
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            var index = SmartCanvas.collection.indexOf(this);

            /* istanbul ignore else */
            if (~index) {
                SmartCanvas.collection.splice(index, 1);
            }

            this.context.clearRect(-this.drawX, -this.drawY, this.drawWidth, this.drawHeight);

            // dereference all created elements
            this.context.max = null;
            delete this.context.max;

            this.context.maxRadius = null;
            delete this.context.maxRadius;

            this.context = null;
            this.contextClone = null;
            this.elementClone = null;
            this.element = null;

            /**
             * On canvas redraw event callback
             *
             * @type {function|null|undefined}
             */
            this.onRedraw = null;
        }

        /**
         * Commits the drawings
         */

    }, {
        key: 'commit',
        value: function commit() {
            var scale = SmartCanvas.pixelRatio;

            if (scale !== 1) {
                this.contextClone.scale(scale, scale);
                this.contextClone.save();
            }

            return this;
        }

        /**
         * Redraw this object
         */

    }, {
        key: 'redraw',
        value: function redraw() {
            this.init();

            /**
             * On canvas redraw event callback
             *
             * @type {function(): *}
             */
            this.onRedraw && this.onRedraw();

            return this;
        }

        /**
         * Returns current device pixel ratio
         *
         * @returns {number}
         */

    }], [{
        key: 'redraw',


        /**
         * Forces redraw all canvas in the current collection
         */
        value: function redraw() {
            var i = 0;
            var s = SmartCanvas.collection.length;

            for (; i < s; i++) {
                SmartCanvas.collection[i].redraw();
            }
        }
    }, {
        key: 'pixelRatio',
        get: function get() {
            /* istanbul ignore next */
            //noinspection JSUnresolvedVariable
            return ns.devicePixelRatio || 1;
        }
    }]);

    return SmartCanvas;
}();

SmartCanvas.collection = [];

/* istanbul ignore next: very browser-specific testing required to cover */
//noinspection JSUnresolvedVariable
if (ns.matchMedia) {
    //noinspection JSUnresolvedFunction
    ns.matchMedia('screen and (min-resolution: 2dppx)').addListener(SmartCanvas.redraw);
}

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Describes rendering target element. Can be either string identifier of
 * the element or the element itself.
 *
 * @typedef {HTMLElement|string} RenderTarget
 */

/**
 * Highlight area definition.
 * It describes highlight area starting from value to value using
 * color. Color can be describes with hex, rgb or rgba value.
 *
 * @typedef {{ from: number, to: number, color: string}} Highlight
 */

/**
 * Shared generic gauges options
 *
 * @type {{renderTo: RenderTarget, width: number, height: number, minValue: number, maxValue: number, value: number, units: string|boolean, majorTicks: number[]|string[], minorTicks: number, strokeTicks: boolean, animatedValue: boolean, animateOnInit: boolean, title: string|boolean, borders: boolean, valueInt: number, valueDec: number, majorTicksInt: number, majorTicksDec: number, animation: boolean, animationDuration: number, animationRule: string|AnimationRule, colorPlate: string, colorPlateEnd: string, colorMajorTicks: string, colorMinorTicks: string, colorTitle: string, colorUnits: string, colorNumbers: string, colorNeedle: string, colorNeedleEnd: string, colorValueText: string, colorValueTextShadow: string, colorBorderShadow: string, colorBorderOuter: string, colorBorderOuterEnd: string, colorBorderMiddle: string, colorBorderMiddleEnd: string, colorBorderInner: string, colorBorderInnerEnd: string, colorValueBoxRect: string, colorValueBoxRectEnd: string, colorValueBoxBackground: string, colorValueBoxShadow: string, colorNeedleShadowUp: string, colorNeedleShadowDown: string, needle: boolean, needleShadow: boolean, needleType: string, needleStart: number, needleEnd: number, needleWidth: number, borderOuterWidth: number, borderMiddleWidth: number, borderInnerWidth: number, borderShadowWidth: number, valueBox: boolean, valueBoxWidth: number, valueBoxStroke: number, valueText: string, valueTextShadow: boolean, valueBoxBorderRadius: number, highlights: Highlight[], highlightsWidth: number, fontNumbers: string, fontTitle: string, fontUnits: string, fontValue: string, fontTitleSize: number, fontValueSize: number, fontUnitsSize: number, fontNumbersSize: number, fontNumbersStyle: string, fontTitleStyle: string, fontUnitsStyle: string, fontValueStyle: string, fontNumbersWeight: string, fontTitleWeight: string, fontUnitsWeight: string, fontValueWeight: string}} GenericOptions
 */
var GenericOptions = {
    // basic options
    renderTo: null,
    width: 0,
    height: 0,
    minValue: 0,
    maxValue: 100,
    value: 0,
    units: false,
    majorTicks: [0, 20, 40, 60, 80, 100],
    minorTicks: 10,
    strokeTicks: true,
    animatedValue: false,
    animateOnInit: false,
    title: false,
    borders: true,

    // number formats
    valueInt: 3,
    valueDec: 2,
    majorTicksInt: 1,
    majorTicksDec: 0,

    // animations
    animation: true,
    animationDuration: 500,
    animationRule: 'cycle',

    // colors
    colorPlate: '#fff',
    colorPlateEnd: '',
    colorMajorTicks: '#444',
    colorMinorTicks: '#666',
    colorTitle: '#888',
    colorUnits: '#888',
    colorNumbers: '#444',
    colorNeedle: 'rgba(240,128,128,1)',
    colorNeedleEnd: 'rgba(255,160,122,.9)',
    colorValueText: '#444',
    colorValueTextShadow: 'rgba(0,0,0,0.3)',
    colorBorderShadow: 'rgba(0,0,0,0.5)',
    colorBorderOuter: '#ddd',
    colorBorderOuterEnd: '#aaa',
    colorBorderMiddle: '#eee',
    colorBorderMiddleEnd: '#f0f0f0',
    colorBorderInner: '#fafafa',
    colorBorderInnerEnd: '#ccc',
    colorValueBoxRect: '#888',
    colorValueBoxRectEnd: '#666',
    colorValueBoxBackground: '#babab2',
    colorValueBoxShadow: 'rgba(0,0,0,1)',
    colorNeedleShadowUp: 'rgba(2,255,255,0.2)',
    colorNeedleShadowDown: 'rgba(188,143,143,0.45)',

    fontNumbers: 'Arial',
    fontTitle: 'Arial',
    fontUnits: 'Arial',
    fontValue: 'Arial',

    fontNumbersSize: 20,
    fontTitleSize: 24,
    fontUnitsSize: 22,
    fontValueSize: 40,

    fontNumbersStyle: 'normal',
    fontTitleStyle: 'normal',
    fontUnitsStyle: 'normal',
    fontValueStyle: 'normal',

    fontNumbersWeight: 'normal',
    fontTitleWeight: 'normal',
    fontUnitsWeight: 'normal',
    fontValueWeight: 'normal',

    // needle
    needle: true,
    needleShadow: true,
    needleType: 'arrow',
    needleStart: 5,
    needleEnd: 85,
    needleWidth: 4,

    // borders
    borderOuterWidth: 3,
    borderMiddleWidth: 3,
    borderInnerWidth: 3,
    borderShadowWidth: 3,

    // value and highlights
    valueBox: true,
    valueBoxStroke: 5,
    valueBoxWidth: 0,
    valueText: '',
    valueTextShadow: true,
    valueBoxBorderRadius: 2.5,

    // highlights
    highlights: [{ from: 20, to: 60, color: '#eee' }, { from: 60, to: 80, color: '#ccc' }, { from: 80, to: 100, color: '#999' }],
    highlightsWidth: 15
};

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Gauge collections type.
 *
 * It is used ES5 declaration here, because babel
 * transpiles inheritance incorrectly in this case.
 *
 * @class Collection
 * @constructor
 */
function Collection() {
    Array.prototype.constructor.apply(this, arguments);
}

Collection.prototype = Object.create(Array.prototype);
Collection.prototype.constructor = Collection;

/**
 * Returns gauge object by its identifier or index in the collection
 *
 * @param {string|number} id
 * @return {*}
 */
Collection.prototype.get = function (id) {
    if (typeof id === 'string') {
        var i = 0;
        var s = this.length;

        for (; i < s; i++) {
            var canvas = this[i].options.renderTo.tagName ? this[i].options.renderTo :
            /* istanbul ignore next: should be tested with e2e tests */
            document.getElementById(this[i].options.renderTo || '');

            if (canvas.getAttribute('id') === id) {
                return this[i];
            }
        }
    } else if (typeof id === 'number') {
        return this[id];
    }

    return null;
};

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

var version = '2.0.8';

var round = Math.round;
var abs = Math.abs;

var gauges = new Collection();

gauges.version = version;

/**
 * Basic abstract BaseGauge class implementing common functionality
 * for different type of gauges.
 *
 * It should not be instantiated directly but must be extended by a final
 * gauge implementation.
 *
 * @abstract
 * @example
 *
 * class MyCoolGauge extends BaseGauge {
 *
 *     // theses methods below MUST be implemented:
 *
 *     constructor(options) {
 *        // ... do something with options
 *        super(options);
 *        // ... implement anything else
 *     }
 *
 *     draw() {
 *         // ... some implementation here
 *         return this;
 *     }
 * }
 */

var BaseGauge = function () {

    /**
     * @constructor
     * @abstract
     * @param {GenericOptions} options
     */
    function BaseGauge(options) {
        _classCallCheck(this, BaseGauge);

        var className = this.constructor.name;

        if (className === 'BaseGauge') {
            throw new TypeError('Attempt to instantiate abstract class!');
        }

        gauges.push(this);

        /**
         * Gauges version string
         *
         * @type {string}
         */
        this.version = version;

        /**
         * Gauge type class
         *
         * @type {BaseGauge} type
         */
        this.type = ns[className];

        /**
         * True if gauge has been drawn for the first time, false otherwise.
         *
         * @type {boolean}
         */
        this.initialized = false;

        options.minValue = parseFloat(options.minValue);
        options.maxValue = parseFloat(options.maxValue);
        options.value = parseFloat(options.value) || 0;

        if (!options.borders) {
            options.borderInnerWidth = options.borderMiddleWidth = options.borderOuterWidth = 0;
        }

        if (!options.renderTo) {
            throw TypeError('Canvas element was not specified when creating ' + 'the Gauge object!');
        }

        var canvas = options.renderTo.tagName ? options.renderTo :
        /* istanbul ignore next: to be tested with e2e tests */
        document.getElementById(options.renderTo);

        if (!(canvas instanceof HTMLCanvasElement)) {
            throw TypeError('Given gauge canvas element is invalid!');
        }

        options.width = parseFloat(options.width) || 0;
        options.height = parseFloat(options.height) || 0;

        if (!options.width || !options.height) {
            if (!options.width) options.width = canvas.parentNode ? canvas.parentNode.offsetWidth : canvas.offsetWidth;
            if (!options.height) options.height = canvas.parentNode ? canvas.parentNode.offsetHeight : canvas.offsetHeight;
        }

        /**
         * Gauge options
         *
         * @type {GenericOptions} options
         */
        this.options = options || {};

        if (this.options.animateOnInit) {
            this._value = this.options.value;
            this.options.value = this.options.minValue;
        }

        /**
         * @type {SmartCanvas} canvas
         */
        this.canvas = new SmartCanvas(canvas, options.width, options.height);
        this.canvas.onRedraw = this.draw.bind(this);

        /**
         * @type {Animation} animation
         */
        this.animation = new Animation(options.animationRule, options.animationDuration);
    }

    /**
     * Sets new value for this gauge.
     * If gauge is animated by configuration it will trigger a proper animation.
     * Upsetting a value triggers gauge redraw.
     *
     * @param {number} value
     */


    _createClass(BaseGauge, [{
        key: 'update',


        /**
         * Updates gauge configuration options at runtime and redraws the gauge
         *
         * @param {RadialGaugeOptions} options
         * @returns {BaseGauge}
         */
        value: function update(options) {
            Object.assign(this.options, options || {});

            this.canvas.width = this.options.width;
            this.canvas.height = this.options.height;

            this.animation.rule = this.options.animationRule;
            this.animation.duration = this.options.animationDuration;

            this.canvas.redraw();

            return this;
        }

        /**
         * Performs destruction of this object properly
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            var index = gauges.indexOf(this);

            /* istanbul ignore else */
            if (~index) {
                //noinspection JSUnresolvedFunction
                gauges.splice(index, 1);
            }

            this.canvas.destroy();
            this.canvas = null;

            this.animation.destroy();
            this.animation = null;
        }

        /**
         * Returns gauges version string
         *
         * @return {string}
         */

    }, {
        key: 'draw',


        /**
         * Triggering gauge render on a canvas.
         *
         * @abstract
         * @returns {BaseGauge}
         */
        value: function draw() {
            if (this.options.animateOnInit && !this.initialized) {
                this.value = this._value;
                this.initialized = true;
            }
        }

        /**
         * Inject given gauge object into DOM
         *
         * @param {string} type
         * @param {GenericOptions} options
         */

    }, {
        key: 'value',
        set: function set(value) {
            var _this4 = this;

            value = parseFloat(value);

            if (isNaN(value) || !isFinite(value)) {
                value = this.options.minValue;
            }

            var fromValue = this.options.value;

            if (value === this.options.value) return;

            if (this.options.animation) {
                /**
                 * @type {number}
                 * @access private
                 */
                this._value = value;

                this.animation.animate(function (percent) {
                    _this4.options.value = fromValue + (value - fromValue) * percent;

                    _this4.draw();
                }, function () {
                    _this4.options.value = value;
                    delete _this4._value;
                    _this4.draw();
                });
            } else {
                this.options.value = value;
                this.draw();
            }
        }

        /**
         * Returns current value of the gauge
         *
         * @return {number}
         */
        ,
        get: function get() {
            return typeof this._value === 'undefined' ? this.options.value : this._value;
        }
    }], [{
        key: 'initialize',
        value: function initialize(type, options) {
            new DomObserver(options, 'canvas', type);
        }
    }, {
        key: 'version',
        get: function get() {
            return version;
        }
    }]);

    return BaseGauge;
}();

/**
 * @ignore
 * @typedef {object} ns
 */
/* istanbul ignore if */


if (typeof ns !== 'undefined') {
    ns['BaseGauge'] = BaseGauge;
    (ns.document || ns)['gauges'] = gauges;
}

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * @access private
 * @typedef {CanvasRenderingContext2D|{max: number, maxRadius: number, barDimensions: object}} Canvas2DContext
 */

/* istanbul ignore next: private, not testable */
/**
 * Examines if a given error is something to throw or to ignore
 *
 * @param {Error} err
 */
function verifyError(err) {
    // there is some unpredictable error in FF in some circumstances
    // which we found simply safe to ignore than to fight with it
    // noinspection JSUnresolvedVariable
    if (err instanceof DOMException && err.result === 0x8053000b) {
        return; // ignore it
    }

    throw err;
}

/* istanbul ignore next: private, not testable */
/**
 * Prepares major ticks data
 *
 * @access private
 * @param {GenericOptions|{ tickSide: string }} options
 * @return {[boolean, boolean]}
 */
function prepareTicks(options) {
    if (!(options.majorTicks instanceof Array)) {
        options.majorTicks = options.majorTicks ? [options.majorTicks] : [];
    }

    if (!options.majorTicks.length) {
        options.majorTicks.push(drawings.formatMajorTickNumber(options.minValue, options));
        options.majorTicks.push(drawings.formatMajorTickNumber(options.maxValue, options));
    }

    return [options.tickSide !== 'right', options.tickSide !== 'left'];
}

/* istanbul ignore next: private, not testable */
/**
 * Draws rounded corners rectangle
 *
 * @param {Canvas2DContext} context
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {number} r
 */
function roundRect(context, x, y, w, h, r) {
    context.beginPath();

    context.moveTo(x + r, y);
    context.lineTo(x + w - r, y);

    context.quadraticCurveTo(x + w, y, x + w, y + r);
    context.lineTo(x + w, y + h - r);

    context.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    context.lineTo(x + r, y + h);

    context.quadraticCurveTo(x, y + h, x, y + h - r);
    context.lineTo(x, y + r);

    context.quadraticCurveTo(x, y, x + r, y);

    context.closePath();
}

/* istanbul ignore next: private, not testable */
/**
 * Pads a given value with leading zeros using the given options
 *
 * @param {number} val
 * @param {RadialGaugeOptions|{valueInt: number, valueDec: number}} options
 * @returns {string}
 */
function padValue(val, options) {
    var dec = options.valueDec;
    var int = options.valueInt;
    var i = 0;
    var s = void 0,
        strVal = void 0,
        n = void 0;

    val = parseFloat(val);
    n = val < 0;
    val = Math.abs(val);

    if (dec > 0) {
        strVal = val.toFixed(dec).toString().split('.');
        s = int - strVal[0].length;

        for (; i < s; ++i) {
            strVal[0] = '0' + strVal[0];
        }

        strVal = (n ? '-' : '') + strVal[0] + '.' + strVal[1];
    } else {
        strVal = Math.round(val).toString();
        s = int - strVal.length;

        for (; i < s; ++i) {
            strVal = '0' + strVal;
        }

        strVal = (n ? '-' : '') + strVal;
    }

    return strVal;
}

/* istanbul ignore next: private, not testable */
/**
 * Formats a number for display on the dial's plate using the majorTicksFormat
 * config option.
 *
 * @param {number} num number to format
 * @param {object} options
 * @returns {string} formatted number
 */
function formatMajorTickNumber(num, options) {
    var right = void 0,
        hasDec = false;

    // First, force the correct number of digits right of the decimal.
    if (options.majorTicksDec === 0) {
        right = Math.round(num).toString();
    } else {
        right = num.toFixed(options.majorTicksDec);
    }

    // Second, force the correct number of digits left of the decimal.
    if (options.majorTicksInt > 1) {
        // Does this number have a decimal?
        hasDec = ~right.indexOf('.');

        // Is this number a negative number?
        if (~right.indexOf('-')) {
            return '-' + [options.majorTicksInt + options.majorTicksDec + 2 + (hasDec ? 1 : 0) - right.length].join('0') + right.replace('-', '');
        } else {
            return [options.majorTicksInt + options.majorTicksDec + 1 + (hasDec ? 1 : 0) - right.length].join('0') + right;
        }
    }

    return right;
}

/* istanbul ignore next: private, not testable */
/**
 * Transforms degrees to radians
 *
 * @param {number} degrees
 * @returns {number}
 */
function radians(degrees) {
    return degrees * Math.PI / 180;
}

/* istanbul ignore next: private, not testable */
/**
 * Calculates and returns radial point coordinates
 *
 * @param {number} radius
 * @param {number} angle
 * @returns {{x: number, y: number}}
 */
function radialPoint(radius, angle) {
    return { x: -radius * Math.sin(angle), y: radius * Math.cos(angle) };
}

/* istanbul ignore next: private, not testable */
/**
 * Creates and returns linear gradient canvas object
 *
 * @param {Canvas2DContext} context
 * @param {string} colorFrom
 * @param {string} colorTo
 * @param {number} length
 * @param {boolean} [isVertical]
 * @param {number} [from]
 * @returns {CanvasGradient}
 */
function linearGradient(context, colorFrom, colorTo, length) {
    var isVertical = arguments.length <= 4 || arguments[4] === undefined ? true : arguments[4];
    var from = arguments.length <= 5 || arguments[5] === undefined ? 0 : arguments[5];

    var grad = context.createLinearGradient(isVertical ? 0 : from, isVertical ? from : 0, isVertical ? 0 : length, isVertical ? length : 0);

    grad.addColorStop(0, colorFrom);
    grad.addColorStop(1, colorTo);

    return grad;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws the shadow if it was not drawn
 *
 * @param {Canvas2DContext} context
 * @param {GenericOptions} options
 * @param {boolean} shadowDrawn
 * @return {boolean}
 */
function drawShadow(context, options) {
    var shadowDrawn = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

    if (shadowDrawn) {
        context.restore();
        return true;
    }

    context.save();

    var w = options.borderShadowWidth;

    if (w) {
        context.shadowBlur = w;
        context.shadowColor = options.colorBorderShadow;
    }

    return true;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge needle shadow
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawNeedleShadow(context, options) {
    if (!options.needleShadow) return;

    context.shadowOffsetX = 2;
    context.shadowOffsetY = 2;
    context.shadowBlur = 10;
    context.shadowColor = options.colorNeedleShadowDown;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws value box at given position
 *
 * @param {Canvas2DContext} context
 * @param {GenericOptions} options
 * @param {number|string} value
 * @param {number} x
 * @param {number} y
 * @param {number} max
 */
function drawValueBox(context, options, value, x, y, max) {
    if (!options.valueBox) return;

    var text = options.valueText || padValue(value, options);

    context.shadowOffsetX = null;
    context.shadowOffsetY = null;
    context.shadowBlur = null;
    context.shadowColor = '';
    context.strokeStyle = null;
    context.lineWidth = 0;
    context.save();

    context.font = options.fontValueStyle + ' ' + options.fontValueWeight + ' ' + options.fontValueSize * (max / 200) + 'px ' + options.fontValue;
    context.save();
    context.beginPath();

    var th = 0.12 * max;
    var bs = parseFloat(options.valueBoxStroke) || 0;
    var bmax = max * 2 - bs * 2;
    var tw = context.measureText(options.valueText ? text : '-' + padValue(0, options)).width;
    var bw = tw + 0.05 * max;
    var bh = th + 0.07 * max;
    var br = max * options.valueBoxBorderRadius / 100;
    var obw = (parseFloat(options.valueBoxWidth) || 0) / 100 * bmax;

    obw > bw && (bw = obw);
    bw > bmax && (bw = bmax);

    var bx = x - bw / 2;
    var by = y - th - 0.04 * max;

    if (br) roundRect(context, bx, by, bw, bh, br);else context.rect(bx, by, bw, bh);

    var gy = y - 0.12 * max - 0.025 * max + (0.12 * max + 0.045 * max) / 2;

    if (options.valueBoxStroke) {
        var grd = context.createRadialGradient(x, gy, max / 10, x, gy, max / 5);

        grd.addColorStop(0, options.colorValueBoxRect);
        grd.addColorStop(1, options.colorValueBoxRectEnd);

        context.strokeStyle = grd;
        context.lineWidth = max * options.valueBoxStroke / 100;
        context.stroke();
    }

    if (options.colorValueBoxShadow) {
        context.shadowBlur = 0.012 * max;
        context.shadowColor = options.colorValueBoxShadow;
    }

    if (options.colorValueBoxBackground) {
        context.fillStyle = options.colorValueBoxBackground;
        context.fill();
    }

    context.closePath();
    context.restore();

    if (options.valueTextShadow) {
        context.shadowOffsetX = 0.004 * max;
        context.shadowOffsetY = 0.004 * max;
        context.shadowBlur = 0.012 * max;
        context.shadowColor = options.colorValueTextShadow;
    }

    context.fillStyle = options.colorValueText;
    context.textAlign = 'center';
    context.fillText(text, -x, y);
    context.restore();
}

var drawings = {
    roundRect: roundRect,
    padValue: padValue,
    formatMajorTickNumber: formatMajorTickNumber,
    radians: radians,
    radialPoint: radialPoint,
    linearGradient: linearGradient,
    drawNeedleShadow: drawNeedleShadow,
    drawValueBox: drawValueBox,
    verifyError: verifyError,
    prepareTicks: prepareTicks,
    drawShadow: drawShadow
};

drawings;

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

var PI = Math.PI;
var HPI = PI / 2;

/**
 * Gauge configuration options
 *
 * @typedef {GenericOptions|{ticksAngle: number, startAngle: number, colorNeedleCircleOuter: string, colorNeedleCircleOuterEnd: string, colorNeedleCircleInner: string, colorNeedleCircleInnerEnd: string, needleCircleSize: number, needleCircleInner: boolean, needleCircleOuter: boolean, animationTarget: string}} RadialGaugeOptions
 */

/**
 * Default gauge configuration options
 *
 * @access private
 * @type {RadialGaugeOptions}
 */
var defaultRadialGaugeOptions = Object.assign({}, GenericOptions, {
    // basic options
    ticksAngle: 270,
    startAngle: 45,

    // colors
    colorNeedleCircleOuter: '#f0f0f0',
    colorNeedleCircleOuterEnd: '#ccc',
    colorNeedleCircleInner: '#e8e8e8',
    colorNeedleCircleInnerEnd: '#f5f5f5',

    // needle
    needleCircleSize: 10,
    needleCircleInner: true,
    needleCircleOuter: true,

    // custom animations
    animationTarget: 'needle' // 'needle' or 'plate'
});

/* istanbul ignore next: private, not testable */
/**
 * Draws gradient-filled circle on a canvas
 *
 * @access private
 * @param {number} radius
 * @param {number} width
 * @param {Canvas2DContext} context
 * @param {string} start gradient start color
 * @param {string} end gradient end color
 */
function drawRadialBorder(radius, width, context, start, end) {
    context.beginPath();
    context.arc(0, 0, abs(radius), 0, PI * 2, true);
    context.lineWidth = width;
    context.strokeStyle = end ? drawings.linearGradient(context, start, end, radius) : start;
    context.stroke();
    context.closePath();
}

/* istanbul ignore next: private, not testable */
/**
 * Returns max radius without borders for the gauge
 *
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 * @return {number}
 */
function maxRadialRadius(context, options) {
    if (!context.maxRadius) {
        context.maxRadius = context.max - options.borderShadowWidth - options.borderOuterWidth - options.borderMiddleWidth - options.borderInnerWidth + (options.borderOuterWidth ? .5 : 0) + (options.borderMiddleWidth ? .5 : 0) + (options.borderInnerWidth ? .5 : 0);
    }

    return context.maxRadius;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge plate on the canvas
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialPlate(context, options) {
    var d0 = options.borderShadowWidth;
    var r0 = context.max - d0 - options.borderOuterWidth / 2;
    var r1 = r0 - options.borderOuterWidth / 2 - options.borderMiddleWidth / 2 + .5;
    var r2 = r1 - options.borderMiddleWidth / 2 - options.borderInnerWidth / 2 + .5;
    var r3 = maxRadialRadius(context, options);
    var grad = void 0;
    var shadowDrawn = false;

    context.save();

    if (options.borderOuterWidth) {
        shadowDrawn = drawings.drawShadow(context, options, shadowDrawn);
        drawRadialBorder(r0, options.borderOuterWidth, context, options.colorBorderOuter, options.colorBorderOuterEnd);
    }

    if (options.borderMiddleWidth) {
        shadowDrawn = drawings.drawShadow(context, options, shadowDrawn);
        drawRadialBorder(r1, options.borderMiddleWidth, context, options.colorBorderMiddle, options.colorBorderMiddleEnd);
    }

    if (options.borderInnerWidth) {
        shadowDrawn = drawings.drawShadow(context, options, shadowDrawn);
        drawRadialBorder(r2, options.borderInnerWidth, context, options.colorBorderInner, options.colorBorderInnerEnd);
    }

    drawings.drawShadow(context, options, shadowDrawn);

    context.beginPath();
    context.arc(0, 0, abs(r3), 0, PI * 2, true);

    if (options.colorPlateEnd) {
        grad = context.createRadialGradient(0, 0, r3 / 2, 0, 0, r3);
        grad.addColorStop(0, options.colorPlate);
        grad.addColorStop(1, options.colorPlateEnd);
    } else {
        grad = options.colorPlate;
    }

    context.fillStyle = grad;

    context.fill();
    context.closePath();

    context.restore();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge highlight areas on a canvas
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialHighlights(context, options) {
    var hlWidth = context.max * (parseFloat(options.highlightsWidth) || 0) / 100;

    if (!hlWidth) return;

    var r = abs(radialTicksRadius(context, options) - hlWidth / 2);
    var i = 0,
        s = options.highlights.length;
    var vd = (options.maxValue - options.minValue) / options.ticksAngle;

    context.save();

    for (; i < s; i++) {
        var hlt = options.highlights[i];

        context.beginPath();

        context.rotate(HPI);
        context.arc(0, 0, r, drawings.radians(options.startAngle + (hlt.from - options.minValue) / vd), drawings.radians(options.startAngle + (hlt.to - options.minValue) / vd), false);
        context.strokeStyle = hlt.color;
        context.lineWidth = hlWidth;
        context.stroke();
        context.closePath();

        context.restore();
        context.save();
    }
}

/* istanbul ignore next: private, not testable */
/**
 * Draws minor ticks bar on a canvas
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialMinorTicks(context, options) {
    var radius = radialTicksRadius(context, options);

    context.lineWidth = SmartCanvas.pixelRatio;
    context.strokeStyle = options.colorMinorTicks;

    context.save();

    var s = options.minorTicks * (options.majorTicks.length - 1);
    var i = 0;

    for (; i < s; ++i) {
        var angle = options.startAngle + i * (options.ticksAngle / s);

        context.rotate(drawings.radians(angle));

        context.beginPath();
        context.moveTo(0, radius);
        context.lineTo(0, radius - context.max * .075);
        closeStrokedPath(context);
    }
}

/* istanbul ignore next: private, not testable */
/**
 * Returns ticks radius
 *
 * @access private
 * @param context
 * @param options
 * @return {number}
 */
function radialTicksRadius(context, options) {
    return maxRadialRadius(context, options) - context.max * .05;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge major ticks bar on a canvas
 *
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialMajorTicks(context, options) {
    drawings.prepareTicks(options);

    var r = abs(radialTicksRadius(context, options));
    var i = void 0,
        colors = void 0;
    var s = options.majorTicks.length;
    var pixelRatio = SmartCanvas.pixelRatio;

    context.lineWidth = 2 * pixelRatio;
    context.save();

    colors = options.colorMajorTicks instanceof Array ? options.colorMajorTicks : Array(s).fill(options.colorMajorTicks);

    i = 0;
    for (; i < s; ++i) {
        context.strokeStyle = colors[i];
        context.rotate(drawings.radians(radialNextAngle(options, i, s)));

        context.beginPath();
        context.moveTo(0, r);
        context.lineTo(0, r - context.max * .15);
        closeStrokedPath(context);
    }

    if (options.strokeTicks) {
        context.strokeStyle = colors[0];
        context.rotate(HPI);

        context.beginPath();
        context.arc(0, 0, r, drawings.radians(options.startAngle), drawings.radians(options.startAngle + options.ticksAngle), false);
        closeStrokedPath(context);
    }
}

/* istanbul ignore next: private, not testable */
function radialNextAngle(options, i, s) {
    return options.startAngle + i * (options.ticksAngle / (s - 1));
}

/* istanbul ignore next: private, not testable */
/**
 * Strokes, closes path and restores previous context state
 *
 * @param {Canvas2DContext} context
 */
function closeStrokedPath(context) {
    context.stroke();
    context.restore();
    context.closePath();
    context.save();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge bar numbers
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialNumbers(context, options) {
    var radius = maxRadialRadius(context, options) - context.max * .35;
    var points = {};
    var i = 0;
    var s = options.majorTicks.length;
    var isAnimated = options.animationTarget !== 'needle';
    var colors = options.colorNumbers instanceof Array ? options.colorNumbers : Array(s).fill(options.colorNumbers);

    var plateValueAngle = isAnimated ? -(options.value - options.minValue) / (options.maxValue - options.minValue) * options.ticksAngle : 0;

    if (isAnimated) {
        context.save();
        context.rotate(-drawings.radians(plateValueAngle));
    }

    for (; i < s; ++i) {
        var angle = plateValueAngle + radialNextAngle(options, i, s);
        var point = drawings.radialPoint(radius, drawings.radians(angle));

        if (angle === 360) angle = 0;

        if (points[angle]) {
            continue; //already drawn at this place, skipping
        }

        points[angle] = true;

        context.font = options.fontNumbersStyle + ' ' + options.fontNumbersWeight + ' ' + options.fontNumbersSize * (context.max / 200) + 'px ' + options.fontNumbers;
        context.fillStyle = colors[i];
        context.lineWidth = 0;
        context.textAlign = 'center';
        context.fillText(options.majorTicks[i], point.x, point.y + 3);
    }

    isAnimated && context.restore();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge title
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialTitle(context, options) {
    if (!options.title) return;

    context.save();
    context.font = options.fontTitleStyle + ' ' + options.fontTitleWeight + ' ' + options.fontTitleSize * (context.max / 200) + 'px ' + options.fontTitle;
    context.fillStyle = options.colorTitle;
    context.textAlign = 'center';
    context.fillText(options.title, 0, -context.max / 4.25, context.max * .8);
    context.restore();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws units name on the gauge
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialUnits(context, options) {
    if (!options.units) return;

    context.save();
    context.font = options.fontUnitsStyle + ' ' + options.fontUnitsWeight + '' + options.fontUnitsSize * (context.max / 200) + 'px ' + options.fontUnits;
    context.fillStyle = options.colorUnits;
    context.textAlign = 'center';
    context.fillText(options.units, 0, context.max / 3.25, context.max * .8);
    context.restore();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge needle
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 */
function drawRadialNeedle(context, options) {
    if (!options.needle) return;

    var value = options.value;
    var max = maxRadialRadius(context, options);
    var r1 = abs(max / 100 * options.needleCircleSize);
    var r2 = abs(max / 100 * options.needleCircleSize * 0.75);
    var rIn = abs(max / 100 * options.needleEnd);
    var rStart = abs(options.needleStart ? max / 100 * options.needleStart : 0);
    var rOut = abs(max * .2);
    var pad1 = max / 100 * options.needleWidth;
    var pad2 = max / 100 * options.needleWidth / 2;
    var pixelRatio = SmartCanvas.pixelRatio;
    var isFixed = options.animationTarget !== 'needle';

    context.save();

    drawings.drawNeedleShadow(context, options);

    context.rotate(drawings.radians(isFixed ? options.startAngle : options.startAngle + (value - options.minValue) / (options.maxValue - options.minValue) * options.ticksAngle));

    context.fillStyle = drawings.linearGradient(context, options.colorNeedle, options.colorNeedleEnd, rIn - rOut);

    if (options.needleType === 'arrow') {
        context.beginPath();
        context.moveTo(-pad2, -rOut);
        context.lineTo(-pad1, 0);
        context.lineTo(-1 * pixelRatio, rIn);
        context.lineTo(pixelRatio, rIn);
        context.lineTo(pad1, 0);
        context.lineTo(pad2, -rOut);
        context.closePath();
        context.fill();

        context.beginPath();
        context.lineTo(-0.5 * pixelRatio, rIn);
        context.lineTo(-1 * pixelRatio, rIn);
        context.lineTo(-pad1, 0);
        context.lineTo(-pad2, -rOut);
        context.lineTo(pad2 / 2 * pixelRatio - 2 * pixelRatio, -rOut);
        context.closePath();
        context.fillStyle = options.colorNeedleShadowUp;
        context.fill();
    } else {
        // simple line needle
        context.beginPath();
        context.moveTo(-pad2, rIn);
        context.lineTo(-pad2, rStart);
        context.lineTo(pad2, rStart);
        context.lineTo(pad2, rIn);
        context.closePath();
        context.fill();
    }

    if (options.needleCircleSize) {
        context.restore();

        drawings.drawNeedleShadow(context, options);

        if (options.needleCircleOuter) {
            context.beginPath();
            context.arc(0, 0, r1, 0, PI * 2, true);
            context.fillStyle = drawings.linearGradient(context, options.colorNeedleCircleOuter, options.colorNeedleCircleOuterEnd, r1);
            context.fill();
            context.closePath();
        }

        if (options.needleCircleInner) {
            context.beginPath();
            context.arc(0, 0, r2, 0, PI * 2, true);
            context.fillStyle = drawings.linearGradient(context, options.colorNeedleCircleInner, options.colorNeedleCircleInnerEnd, r2);
            context.fill();
            context.closePath();
        }

        context.restore();
    }
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge value box
 *
 * @param {Canvas2DContext} context
 * @param {RadialGaugeOptions} options
 * @param {number} value
 */
function drawRadialValueBox(context, options, value) {
    drawings.drawValueBox(context, options, value, 0, context.max - context.max * .33, context.max);
}

/**
 * Minimalistic HTML5 Canvas Gauge
 * @example
 *  var gauge = new RadialGauge({
 *     renderTo: 'gauge-id', // identifier of HTML canvas element or element itself
 *     width: 400,
 *     height: 400,
 *     units: 'Km/h',
 *     title: false,
 *     value: 0,
 *     minValue: 0,
 *     maxValue: 220,
 *     majorTicks: [
 *         '0','20','40','60','80','100','120','140','160','180','200','220'
 *     ],
 *     minorTicks: 2,
 *     strokeTicks: false,
 *     highlights: [
 *         { from: 0, to: 50, color: 'rgba(0,255,0,.15)' },
 *         { from: 50, to: 100, color: 'rgba(255,255,0,.15)' },
 *         { from: 100, to: 150, color: 'rgba(255,30,0,.25)' },
 *         { from: 150, to: 200, color: 'rgba(255,0,225,.25)' },
 *         { from: 200, to: 220, color: 'rgba(0,0,255,.25)' }
 *     ],
 *     colorPlate: '#222',
 *     colorMajorTicks: '#f5f5f5',
 *     colorMinorTicks: '#ddd',
 *     colorTitle: '#fff',
 *     colorUnits: '#ccc',
 *     colorNumbers: '#eee',
 *     colorNeedleStart: 'rgba(240, 128, 128, 1)',
 *     colorNeedleEnd: 'rgba(255, 160, 122, .9)',
 *     valueBox: true,
 *     animationRule: 'bounce'
 * });
 * // draw initially
 * gauge.draw();
 * // animate
 * setInterval(() => {
 *    gauge.value = Math.random() * -220 + 220;
 * }, 1000);
 */

var RadialGauge = function (_BaseGauge) {
    _inherits(RadialGauge, _BaseGauge);

    /**
     * @constructor
     * @param {RadialGaugeOptions} options
     */
    function RadialGauge(options) {
        _classCallCheck(this, RadialGauge);

        options = Object.assign({}, defaultRadialGaugeOptions, options || {});

        /* istanbul ignore if */
        if (isNaN(options.startAngle)) options.startAngle = 45;
        /* istanbul ignore if */
        if (isNaN(options.ticksAngle)) options.ticksAngle = 270;

        /* istanbul ignore if */
        if (options.ticksAngle > 360) options.ticksAngle = 360;
        /* istanbul ignore if */
        if (options.ticksAngle < 0) options.ticksAngle = 0;

        /* istanbul ignore if */
        if (options.startAngle < 0) options.startAngle = 0;
        /* istanbul ignore if */
        if (options.startAngle > 360) options.startAngle = 360;

        return _possibleConstructorReturn(this, (RadialGauge.__proto__ || Object.getPrototypeOf(RadialGauge)).call(this, options));
    }

    /*  */
    /**
     * Triggering gauge render on a canvas.
     *
     * @returns {RadialGauge}
     */


    _createClass(RadialGauge, [{
        key: 'draw',
        value: function draw() {
            try {
                var canvas = this.canvas;
                var x = -canvas.drawX;
                var y = -canvas.drawY;
                var w = canvas.drawWidth;
                var h = canvas.drawHeight;

                var options = this.options;

                if (options.animationTarget === 'needle') {
                    if (!canvas.elementClone.initialized) {
                        var context = canvas.contextClone;

                        // clear the cache
                        context.clearRect(x, y, w, h);
                        context.save();

                        drawRadialPlate(context, options);
                        drawRadialHighlights(context, options);
                        drawRadialMinorTicks(context, options);
                        drawRadialMajorTicks(context, options);
                        drawRadialNumbers(context, options);
                        drawRadialTitle(context, options);
                        drawRadialUnits(context, options);

                        canvas.elementClone.initialized = true;
                    }

                    this.canvas.commit();

                    // clear the canvas
                    canvas.context.clearRect(x, y, w, h);
                    canvas.context.save();

                    canvas.context.drawImage(canvas.elementClone, x, y, w, h);
                    canvas.context.save();

                    drawRadialValueBox(canvas.context, options, options.animatedValue ? this.options.value : this.value);
                    drawRadialNeedle(canvas.context, options);
                } else {
                    var plateValueAngle = -drawings.radians((options.value - options.minValue) / (options.maxValue - options.minValue) * options.ticksAngle);

                    // clear the canvas
                    canvas.context.clearRect(x, y, w, h);
                    canvas.context.save();

                    drawRadialPlate(canvas.context, options);

                    canvas.context.rotate(plateValueAngle);

                    // animated
                    drawRadialHighlights(canvas.context, options);
                    drawRadialMinorTicks(canvas.context, options);
                    drawRadialMajorTicks(canvas.context, options);
                    drawRadialNumbers(canvas.context, options);

                    // non-animated
                    canvas.context.rotate(-plateValueAngle);
                    canvas.context.save();

                    if (!canvas.elementClone.initialized) {
                        var _context = canvas.contextClone;

                        // clear the cache
                        _context.clearRect(x, y, w, h);
                        _context.save();

                        drawRadialTitle(_context, options);
                        drawRadialUnits(_context, options);
                        drawRadialNeedle(_context, options);

                        canvas.elementClone.initialized = true;
                    }

                    canvas.context.drawImage(canvas.elementClone, x, y, w, h);
                }

                // value box animations
                drawRadialValueBox(canvas.context, options, options.animatedValue ? this.options.value : this.value);

                _get(RadialGauge.prototype.__proto__ || Object.getPrototypeOf(RadialGauge.prototype), 'draw', this).call(this);
            } catch (err) {
                drawings.verifyError(err);
            }

            return this;
        }
    }]);

    return RadialGauge;
}(BaseGauge);

/**
 * @ignore
 * @typedef {object} ns
 */
/* istanbul ignore if */


if (typeof ns !== 'undefined') {
    ns['RadialGauge'] = RadialGauge;
}

BaseGauge.initialize('RadialGauge', defaultRadialGaugeOptions);

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Linear gauge configuration options
 *
 * @typedef {GenericOptions|{borderRadius: number, barBeginCircle: number, barWidth: number, barStrokeWidth: number, barProgress: boolean, colorBar: string, colorBarEnd: string, colorBarStroke: string, colorBarProgress: string, colorBarProgressEnd: string, tickSide: string, needleSide: string, numberSide: string, ticksWidth: number, ticksWidthMinor: number, ticksPadding: number, barLength: number}} LinearGaugeOptions
 */

/**
 * Default linear gauge configuration options
 *
 * @type {LinearGaugeOptions}
 */
var defaultLinearGaugeOptions = Object.assign({}, GenericOptions, {
    // basic options
    borderRadius: 0,
    // width: 150,
    // height: 400,

    // bar
    barBeginCircle: 30, // percents
    barWidth: 20, // percents
    barStrokeWidth: 0, // pixels
    barProgress: true,

    colorBarStroke: '#222',
    colorBar: '#ccc',
    colorBarEnd: '',
    colorBarProgress: '#888',
    colorBarProgressEnd: '',

    needleWidth: 6,

    tickSide: 'both', // available: 'left', 'right', 'both'
    needleSide: 'both', // available: 'left', 'right', 'both'

    numberSide: 'both', // available: 'left', 'right', 'both'

    ticksWidth: 10,
    ticksWidthMinor: 5,
    ticksPadding: 5,
    barLength: 85,
    fontTitleSize: 26,

    highlightsWidth: 10
});

/* istanbul ignore next: private, not testable */
/**
 * Draws rectangle on a canvas
 *
 * @param {Canvas2DContext} context
 * @param {number} r radius for founded corner rectangle if 0 or less won't be drawn
 * @param {number} x x-coordinate of the top-left corner
 * @param {number} y y-coordinate of the top-left corner
 * @param {number} w width of the rectangle
 * @param {number} h height of the rectangle
 * @param {string} colorStart base fill color of the rectangle
 * @param {string} [colorEnd] gradient color of the rectangle
 */
function drawRectangle(context, r, x, y, w, h, colorStart, colorEnd) {
    context.beginPath();
    context.fillStyle = colorEnd ? drawings.linearGradient(context, colorStart, colorEnd, w > h ? w : h, h > w, w > h ? x : y) : colorStart;

    r > 0 ? drawings.roundRect(context, x, y, w, h, r) : context.rect(x, y, w, h);

    context.fill();
    context.closePath();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws rectangle on a canvas
 *
 * @param {Canvas2DContext} context
 * @param {number} width width of the border
 * @param {number} r radius for founded corner rectangle if 0 or less won't be drawn
 * @param {number} x x-coordinate of the top-left corner
 * @param {number} y y-coordinate of the top-left corner
 * @param {number} w width of the rectangle
 * @param {number} h height of the rectangle
 * @param {string} colorStart base fill color of the rectangle
 * @param {string} [colorEnd] gradient color of the rectangle
 */
function drawLinearBorder(context, width, r, x, y, w, h, colorStart, colorEnd) {
    context.beginPath();
    context.lineWidth = width;
    context.strokeStyle = colorEnd ? drawings.linearGradient(context, colorStart, colorEnd, h, true, y) : colorStart;

    r > 0 ? drawings.roundRect(context, x, y, w, h, r) : context.rect(x, y, w, h);

    context.stroke();
    context.closePath();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws linear gauge plate
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 */
function drawLinearPlate(context, options, x, y, w, h) {
    context.save();

    var r = options.borderRadius;
    var w1 = w - options.borderShadowWidth - options.borderOuterWidth;
    var w2 = w1 - options.borderOuterWidth - options.borderMiddleWidth;
    var w3 = w2 - options.borderMiddleWidth - options.borderInnerWidth;
    var w4 = w3 - options.borderInnerWidth;

    var h1 = h - options.borderShadowWidth - options.borderOuterWidth;
    var h2 = h1 - options.borderOuterWidth - options.borderMiddleWidth;
    var h3 = h2 - options.borderMiddleWidth - options.borderInnerWidth;
    var h4 = h3 - options.borderInnerWidth;

    var x2 = x - (w2 - w1) / 2;
    var x3 = x2 - (w3 - w2) / 2;
    var x4 = x3 - (w4 - w3) / 2;

    var y2 = y - (h2 - h1) / 2;
    var y3 = y2 - (h3 - h2) / 2;
    var y4 = y3 - (h4 - h3) / 2;
    var aliasingOffset = 0;
    var shadowDrawn = false;

    if (options.borderOuterWidth) {
        shadowDrawn = drawings.drawShadow(context, options, shadowDrawn);
        drawLinearBorder(context, options.borderOuterWidth, r, x + options.borderOuterWidth / 2 - aliasingOffset, y + options.borderOuterWidth / 2 - aliasingOffset, w1, h1, options.colorBorderOuter, options.colorBorderOuterEnd);
        aliasingOffset += .5;
    }

    if (options.borderMiddleWidth) {
        shadowDrawn = drawings.drawShadow(context, options, shadowDrawn);
        drawLinearBorder(context, options.borderMiddleWidth, r -= 1 + aliasingOffset * 2, x2 + options.borderMiddleWidth / 2 - aliasingOffset, y2 + options.borderMiddleWidth / 2 - aliasingOffset, w2 + aliasingOffset * 2, h2 + aliasingOffset * 2, options.colorBorderMiddle, options.colorBorderMiddleEnd);
        aliasingOffset += .5;
    }

    if (options.borderInnerWidth) {
        shadowDrawn = drawings.drawShadow(context, options, shadowDrawn);
        drawLinearBorder(context, options.borderInnerWidth, r -= 1 + aliasingOffset * 2, x3 + options.borderInnerWidth / 2 - aliasingOffset, y3 + options.borderInnerWidth / 2 - aliasingOffset, w3 + aliasingOffset * 2, h3 + aliasingOffset * 2, options.colorBorderInner, options.colorBorderInnerEnd);
        aliasingOffset += .5;
    }

    drawings.drawShadow(context, options, shadowDrawn);

    drawRectangle(context, r, x4, y4, w4 + aliasingOffset * 2, h4 + aliasingOffset * 2, options.colorPlate, options.colorPlateEnd);

    context.restore();

    return [x4, y4, w4, h4];
}

/* istanbul ignore next: private, not testable */
/**
 * Calculates and returns linear gauge base bar dimensions.
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions|{barStrokeWidth: number, barBeginCircle: number, barWidth: number, hasLeft: boolean, hasRight: boolean}} options
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @return {{isVertical: boolean, width: number, length: number, barWidth: number, barLength: number, strokeWidth: number, barMargin: number, radius: number, x0: number, y0: number, barOffset: number, titleMargin: number, unitsMargin: number, X: number, Y: number, baseX: number, baseY: number, ticksPadding: number}}
 */
function barDimensions(context, options, x, y, w, h) {
    var pixelRatio = SmartCanvas.pixelRatio;
    var isVertical = h >= w;
    var width = isVertical ? w * .85 : h;
    var length = isVertical ? h : w;

    x = isVertical ? round(x + (w - width) / 2) : x;

    var hasTitle = !!options.title;
    var hasUnits = !!options.units;
    var hasValue = !!options.valueBox;

    var titleMargin = void 0;
    var unitsMargin = void 0;
    var valueMargin = void 0;

    if (isVertical) {
        unitsMargin = round(length * .05);
        titleMargin = round(length * .075);
        valueMargin = round(length * .075);

        if (hasTitle) {
            length -= titleMargin;
            y += titleMargin;
        }

        if (hasUnits) length -= unitsMargin;
        if (hasValue) length -= valueMargin;
    } else {
        unitsMargin = titleMargin = round(width * .15);

        if (hasTitle) {
            width -= titleMargin;
            y += titleMargin;
        }

        if (hasUnits) width -= unitsMargin;
    }

    var strokeWidth = options.barStrokeWidth * 2;
    var radius = options.barBeginCircle ? round(width * options.barBeginCircle / 200 - strokeWidth / 2) : 0;

    var barWidth = round(width * options.barWidth / 100 - strokeWidth);
    var barLength = round(length * options.barLength / 100 - strokeWidth);
    var barMargin = round((length - barLength) / 2);

    // coordinates for arc of the bar if configured
    var x0 = round(x + (isVertical ? width / 2 : barMargin + radius));
    var y0 = round(y + (isVertical ? length - barMargin - radius + strokeWidth / 2 : width / 2));
    var dx = isVertical && !(options.hasLeft && options.hasRight) ? (options.hasRight ? -1 : 1) * options.ticksWidth / 100 * width : 0;
    var dy = !isVertical && !(options.hasLeft && options.hasRight) ? (options.hasRight ? -1 : 1) * options.ticksWidth / 100 * width : 0;

    //noinspection JSUndefinedPropertyAssignment
    context.barDimensions = {
        isVertical: isVertical,
        width: width,
        length: length,
        barWidth: barWidth,
        barLength: barLength,
        strokeWidth: strokeWidth,
        barMargin: barMargin,
        radius: radius,
        pixelRatio: pixelRatio,
        barOffset: null,
        titleMargin: hasTitle ? titleMargin : 0,
        unitsMargin: hasUnits ? unitsMargin : 0,
        get ticksLength() {
            return this.barLength - this.barOffset - this.strokeWidth;
        },
        X: x + dx,
        Y: y + dy,
        x0: x0 + dx,
        y0: y0 + dy,
        baseX: x,
        baseY: y,
        ticksPadding: options.ticksPadding / 100
    };

    return context.barDimensions;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws bar shape from the given options on a given canvas context
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {string} type
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 */
function drawLinearBarShape(context, options, type, x, y, w, h) {
    var _barDimensions = barDimensions(context, options, x, y, w, h);

    var isVertical = _barDimensions.isVertical;
    var width = _barDimensions.width;
    var barWidth = _barDimensions.barWidth;
    var barLength = _barDimensions.barLength;
    var strokeWidth = _barDimensions.strokeWidth;
    var barMargin = _barDimensions.barMargin;
    var radius = _barDimensions.radius;
    var x0 = _barDimensions.x0;
    var y0 = _barDimensions.y0;
    var X = _barDimensions.X;
    var Y = _barDimensions.Y;

    var fullBarLength = barLength;

    context.save();
    context.beginPath();

    if (options.barBeginCircle) {
        var direction = drawings.radians(isVertical ? 270 : 0);
        var alpha = Math.asin(barWidth / 2 / radius);
        var cosAlpha = Math.cos(alpha);
        var sinAlpha = Math.sin(alpha);

        var x1 = x0 + (isVertical ? radius * sinAlpha : radius * cosAlpha - strokeWidth / 2);
        var y1 = isVertical ? y0 - radius * cosAlpha : y0 + radius * sinAlpha;
        var cutRadius = isVertical ? abs(y1 - y0) : abs(x1 - x0);

        context.barDimensions.barOffset = round(cutRadius + radius);

        // bottom point
        var x2 = isVertical ? round(x0 - radius * sinAlpha) : x1;
        var y2 = isVertical ? y1 : round(y0 - radius * sinAlpha);

        if (type === 'progress') {
            barLength = context.barDimensions.barOffset + (barLength - context.barDimensions.barOffset) * (options.value - options.minValue) / (options.maxValue - options.minValue);
        }

        // bar ends at
        var x3 = round(x1 + barLength - context.barDimensions.barOffset + strokeWidth / 2); // h
        var y3 = round(y1 - barLength + context.barDimensions.barOffset - strokeWidth / 2); // v

        context.arc(x0, y0, radius, direction + alpha, direction - alpha);

        if (isVertical) {
            context.moveTo(x1, y2);
            context.lineTo(x1, y3);
            context.lineTo(x2, y3);
            context.lineTo(x2, y2);
        } else {
            context.moveTo(x1, y2);
            context.lineTo(x3, y2);
            context.lineTo(x3, y1);
            context.lineTo(x1, y1);
        }
    } else {
        // simply rectangle
        var rx = round(isVertical ? X + (width - barWidth) / 2 : X + barMargin);
        var ry = round(isVertical ? Y + barLength + barMargin : Y + (width - barWidth) / 2);

        if (type === 'progress') {
            barLength *= (options.value - options.minValue) / (options.maxValue - options.minValue);
        }

        if (isVertical) context.rect(rx, ry, barWidth, -barLength);else context.rect(rx, ry, barLength, barWidth);
    }

    if (type !== 'progress' && options.barStrokeWidth) {
        context.lineWidth = strokeWidth;
        context.strokeStyle = options.colorBarStroke;
        //context.lineJoin = 'round';
        context.stroke();
    }

    if (type !== 'progress' && options.colorBar) {
        context.fillStyle = options.colorBarEnd ? drawings.linearGradient(context, options.colorBar, options.colorBarEnd, barLength, isVertical, isVertical ? Y : X) : options.colorBar;
        context.fill();
    } else if (type === 'progress' && options.colorBarProgress) {
        context.fillStyle = options.colorBarProgressEnd ? drawings.linearGradient(context, options.colorBarProgress, options.colorBarProgressEnd, fullBarLength, isVertical, isVertical ? Y : X) : options.colorBarProgress;
        context.fill();
    }

    context.closePath();

    // fix dimensions for further usage
    if (options.barBeginCircle) context.barDimensions.radius += strokeWidth;

    context.barDimensions.barWidth += strokeWidth;
    context.barDimensions.barLength += strokeWidth;
}

/**
 * Draws gauge bar
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {number} x x-coordinate of the top-left corner of the gauge
 * @param {number} y y-coordinate of the top-left corner of the gauge
 * @param {number} w width of the gauge
 * @param {number} h height of the gauge
 */
function drawLinearBar(context, options, x, y, w, h) {
    drawLinearBarShape(context, options, '', x, y, w, h);
}

/* istanbul ignore next: private, not testable */
/**
 * Helper function to calculate bar ticks presence on the sides
 *
 * @param {string} notWhich
 * @param {LinearGaugeOptions} options
 * @return {boolean}
 */
function hasTicksBar(notWhich, options) {
    return options.needleSide !== notWhich || options.tickSide !== notWhich || options.numberSide !== notWhich;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge bar progress
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {number} x x-coordinate of the top-left corner of the gauge
 * @param {number} y y-coordinate of the top-left corner of the gauge
 * @param {number} w width of the gauge
 * @param {number} h height of the gauge
 */
function drawLinearBarProgress(context, options, x, y, w, h) {
    options.barProgress && drawLinearBarShape(context, options, 'progress', x, y, w, h);
}

/* istanbul ignore next: private, not testable */
/**
 * Draws gauge bar highlighted areas
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 */
function drawLinearBarHighlights(context, options) {
    var _context$barDimension = context.barDimensions;
    var isVertical = _context$barDimension.isVertical;
    var width = _context$barDimension.width;
    var length = _context$barDimension.length;
    var barWidth = _context$barDimension.barWidth;
    var barOffset = _context$barDimension.barOffset;
    var barMargin = _context$barDimension.barMargin;
    var X = _context$barDimension.X;
    var Y = _context$barDimension.Y;
    var ticksLength = _context$barDimension.ticksLength;
    var ticksPadding = _context$barDimension.ticksPadding;

    var hlWidth = width * (parseFloat(options.highlightsWidth) || 0) / 100;

    if (!options.highlights || !hlWidth) return;

    var hasLeft = options.tickSide !== 'right';
    var hasRight = options.tickSide !== 'left';
    var i = 0;
    var s = options.highlights.length;
    var tickOffset = (width - barWidth) / 2;
    var interval = options.maxValue - options.minValue;
    var eX = round(isVertical ? X + tickOffset : X + barMargin + barOffset);
    var eH = hlWidth;
    var eY = isVertical ? Y + length - barMargin - barOffset : Y + tickOffset;
    var hLeft = round((options.ticksWidth / 100 + ticksPadding) * width) + (hlWidth - options.ticksWidth / 100 * width);
    var hRight = round(barWidth + ticksPadding * width);

    context.save();

    for (; i < s; i++) {
        var entry = options.highlights[i];
        var eStart = ticksLength * abs(entry.from) / interval;
        var eW = ticksLength * abs((entry.to - entry.from) / interval);

        context.beginPath();
        context.fillStyle = entry.color;

        if (isVertical) {
            if (hasLeft) context.rect(eX - hLeft, eY - eStart, eH, -eW);

            if (hasRight) context.rect(eX + hRight, eY - eStart, eH, -eW);
        } else {
            if (hasLeft) context.rect(eX + eStart, eY - hLeft, eW, eH);

            if (hasRight) context.rect(eX + eStart, eY + hRight, eW, eH);
        }

        context.fill();
        context.closePath();
    }
}

/* istanbul ignore next: private, not testable */
/**
 * Draws a tick line on a linear gauge
 *
 * @param {Canvas2DContext} context
 * @param x1
 * @param y1
 * @param x2
 * @param y2
 */
function drawLinearTick(context, x1, y1, x2, y2) {
    context.beginPath();

    context.moveTo(x1, y1);
    context.lineTo(x2, y2);
    context.stroke();

    context.closePath();
    context.save();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws ticks
 *
 * @param {Canvas2DContext} context
 * @param {string} color
 * @param {number} ticksSize
 * @param {number} deltaLen
 * @param {boolean} hasLeft
 * @param {boolean} hasRight
 * @param {number} lineWidth
 * @param {number} lineLength
 */
function drawLinearTicks(context, color, ticksSize, deltaLen, hasLeft, hasRight, lineWidth, lineLength) {
    var _context$barDimension2 = context.barDimensions;
    var isVertical = _context$barDimension2.isVertical;
    var length = _context$barDimension2.length;
    var barWidth = _context$barDimension2.barWidth;
    var barOffset = _context$barDimension2.barOffset;
    var barMargin = _context$barDimension2.barMargin;
    var pixelRatio = _context$barDimension2.pixelRatio;
    var width = _context$barDimension2.width;
    var X = _context$barDimension2.X;
    var Y = _context$barDimension2.Y;
    var ticksLength = _context$barDimension2.ticksLength;
    var ticksPadding = _context$barDimension2.ticksPadding;

    var tickOffset = (width - barWidth) / 2;
    var tickX = void 0,
        tickY = void 0;
    var i = 0;
    var tickLen = lineLength * width;
    var tickLeft = tickOffset - ticksPadding * width;
    var tickRight = tickOffset + barWidth + tickLen + ticksPadding * width;
    var tickSpace = ticksLength / (ticksSize - deltaLen);
    var colors = color instanceof Array ? color : Array(ticksSize).fill(color);

    context.lineWidth = lineWidth * pixelRatio;
    context.save();

    for (; i < ticksSize; i++) {
        context.strokeStyle = colors[i];

        if (isVertical) {
            tickY = Y + length - barMargin - barOffset - i * tickSpace;

            if (hasLeft) {
                tickX = X + tickLeft;
                drawLinearTick(context, tickX, tickY, round(tickX - tickLen), tickY);
            }

            if (hasRight) {
                tickX = X + tickRight;
                drawLinearTick(context, tickX, tickY, round(tickX - tickLen), tickY);
            }
        } else {
            tickX = X + barMargin + barOffset + i * tickSpace;

            if (hasLeft) {
                tickY = Y + tickLeft;
                drawLinearTick(context, tickX, tickY, tickX, round(tickY - tickLen));
            }

            if (hasRight) {
                tickY = Y + tickRight;
                drawLinearTick(context, tickX, round(tickY), tickX, tickY - tickLen);
            }
        }
    }
}

/* istanbul ignore next: private, not testable */
/**
 * Draws major ticks
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 */
function drawLinearMajorTicks(context, options) {
    var _drawings$prepareTick = drawings.prepareTicks(options);

    var _drawings$prepareTick2 = _slicedToArray(_drawings$prepareTick, 2);

    var hasLeft = _drawings$prepareTick2[0];
    var hasRight = _drawings$prepareTick2[1];

    var lineWidth = 2;
    var colors = options.colorMajorTicks instanceof Array ? options.colorMajorTicks : Array(options.colorMajorTicks.length).fill(options.colorMajorTicks);

    drawLinearTicks(context, options.colorMajorTicks, options.majorTicks.length, 1, hasLeft, hasRight, lineWidth, options.ticksWidth / 100);

    if (options.strokeTicks) {
        var _context$barDimension3 = context.barDimensions;
        var isVertical = _context$barDimension3.isVertical;
        var length = _context$barDimension3.length;
        var width = _context$barDimension3.width;
        var barWidth = _context$barDimension3.barWidth;
        var barMargin = _context$barDimension3.barMargin;
        var barOffset = _context$barDimension3.barOffset;
        var X = _context$barDimension3.X;
        var Y = _context$barDimension3.Y;
        var ticksLength = _context$barDimension3.ticksLength;
        var pixelRatio = _context$barDimension3.pixelRatio;
        var ticksPadding = _context$barDimension3.ticksPadding;

        var rightTicks = (width - barWidth) / 2 + barWidth + ticksPadding * width;
        var leftTicks = (width - barWidth) / 2 - ticksPadding * width;
        var sX = void 0,
            sY = void 0,
            eX = void 0,
            eY = void 0;

        context.strokeStyle = colors[0];

        lineWidth *= pixelRatio;

        if (isVertical) {
            sY = Y + length - barMargin - barOffset + lineWidth / 2;
            eY = sY - ticksLength - lineWidth;

            if (hasLeft) {
                eX = sX = round(X + leftTicks);
                drawLinearTickStroke(context, sX, sY, eX, eY);
            }

            if (hasRight) {
                eX = sX = round(X + rightTicks);
                drawLinearTickStroke(context, sX, sY, eX, eY);
            }
        } else {
            sX = X + barMargin + barOffset - lineWidth / 2;
            eX = sX + ticksLength + lineWidth;

            if (hasLeft) {
                eY = sY = round(Y + leftTicks);
                drawLinearTickStroke(context, sX, sY, eX, eY);
            }

            if (hasRight) {
                eY = sY = round(Y + rightTicks);
                drawLinearTickStroke(context, sX, sY, eX, eY);
            }
        }
    }
}

/* istanbul ignore next: private, not testable */
/**
 * Draws ticks stroke
 *
 * @param {Canvas2DContext} context
 * @param {number} sX
 * @param {number} sY
 * @param {number} eX
 * @param {number} eY
 */
function drawLinearTickStroke(context, sX, sY, eX, eY) {
    context.beginPath();
    context.moveTo(sX, sY);
    context.lineTo(eX, eY);
    context.stroke();
    context.closePath();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws minor ticks
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 */
function drawLinearMinorTicks(context, options) {
    var _drawings$prepareTick3 = drawings.prepareTicks(options);

    var _drawings$prepareTick4 = _slicedToArray(_drawings$prepareTick3, 2);

    var hasLeft = _drawings$prepareTick4[0];
    var hasRight = _drawings$prepareTick4[1];


    drawLinearTicks(context, options.colorMinorTicks, options.minorTicks * (options.majorTicks.length - 1), 0, hasLeft, hasRight, 1, options.ticksWidthMinor / 100);
}

/* istanbul ignore next: private, not testable */
/**
 * Draws major tick numbers
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 */
function drawLinearMajorTicksNumbers(context, options) {
    var _context$barDimension4 = context.barDimensions;
    var isVertical = _context$barDimension4.isVertical;
    var length = _context$barDimension4.length;
    var width = _context$barDimension4.width;
    var barWidth = _context$barDimension4.barWidth;
    var barMargin = _context$barDimension4.barMargin;
    var barOffset = _context$barDimension4.barOffset;
    var X = _context$barDimension4.X;
    var Y = _context$barDimension4.Y;
    var ticksLength = _context$barDimension4.ticksLength;
    var ticksPadding = _context$barDimension4.ticksPadding;

    var ticks = options.majorTicks.length;
    var hasLeft = options.numberSide !== 'right';
    var hasRight = options.numberSide !== 'left';
    var textHeight = options.fontNumbersSize * width / 200;
    var i = 0;
    var ticksWidth = (options.ticksWidth / 100 + ticksPadding * 2) * width;
    var numLeft = (width - barWidth) / 2 - ticksWidth;
    var numRight = (width - barWidth) / 2 + barWidth + ticksWidth;
    var textX = void 0,
        textY = void 0,
        textWidth = void 0,
        numberOffset = void 0,
        tick = void 0;
    var colors = options.colorNumbers instanceof Array ? options.colorNumbers : Array(ticks).fill(options.colorNumbers);

    context.font = options.fontNumbersStyle + ' ' + options.fontNumbersWeight + ' ' + textHeight + 'px ' + options.fontNumbers;
    context.lineWidth = 0;
    context.textAlign = 'center';

    for (; i < ticks; i++) {
        context.fillStyle = colors[i];
        tick = options.majorTicks[i];
        numberOffset = i * ticksLength / (ticks - 1);

        if (isVertical) {
            textY = Y + length - barMargin - barOffset - numberOffset + textHeight / 3;

            if (hasLeft) {
                context.textAlign = 'right';
                context.fillText(tick, X + numLeft, textY);
            }

            if (hasRight) {
                context.textAlign = 'left';
                context.fillText(tick, X + numRight, textY);
            }
        } else {
            textWidth = context.measureText(tick).width;
            textX = X + barMargin + barOffset + numberOffset;

            if (hasLeft) {
                context.fillText(tick, textX, Y + numLeft);
            }

            if (hasRight) {
                context.fillText(tick, textX, Y + numRight + textHeight);
            }
        }
    }
}

/* istanbul ignore next: private, not testable */
/**
 * Draws linear gauge title
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 */
function drawLinearTitle(context, options) {
    if (!options.title) return;

    var _context$barDimension5 = context.barDimensions;
    var isVertical = _context$barDimension5.isVertical;
    var width = _context$barDimension5.width;
    var length = _context$barDimension5.length;
    var baseX = _context$barDimension5.baseX;
    var baseY = _context$barDimension5.baseY;
    var titleMargin = _context$barDimension5.titleMargin;

    var textHeight = options.fontTitleSize * width / 200;
    var textX = round(baseX + (isVertical ? width : length) / 2);
    var textY = round(baseY + titleMargin / 2 - (isVertical ? textHeight : textHeight / 2) - .025 * (isVertical ? length : width));

    context.save();
    context.textAlign = 'center';
    context.fillStyle = options.colorTitle;
    context.font = options.fontTitleStyle + ' ' + options.fontTitleWeight + ' ' + textHeight + 'px ' + options.fontTitle;
    context.lineWidth = 0;
    context.fillText(options.title, textX, textY, isVertical ? width : length);
}

/* istanbul ignore next: private, not testable */
/**
 * Draws linear gauge units
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 */
function drawLinearUnits(context, options) {
    if (!options.units) return;

    var _context$barDimension6 = context.barDimensions;
    var isVertical = _context$barDimension6.isVertical;
    var width = _context$barDimension6.width;
    var length = _context$barDimension6.length;
    var baseX = _context$barDimension6.baseX;
    var baseY = _context$barDimension6.baseY;
    var unitsMargin = _context$barDimension6.unitsMargin;

    var textHeight = options.fontUnitsSize * width / 200;
    var textX = round(baseX + (isVertical ? width : length) / 2);
    var textY = round(baseY + (isVertical ? length : width) + unitsMargin / 2 - textHeight / 2);

    context.save();
    context.textAlign = 'center';
    context.fillStyle = options.colorTitle;
    context.font = options.fontUnitsStyle + ' ' + options.fontUnitsWeight + ' ' + textHeight + 'px ' + options.fontUnits;
    context.lineWidth = 0;
    context.fillText(options.units, textX, textY, isVertical ? width : length);
}

/* istanbul ignore next: private, not testable */
/**
 * Draws linear gauge needles
 *
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 */
function drawLinearBarNeedle(context, options) {
    if (!options.needle) return;

    var _context$barDimension7 = context.barDimensions;
    var isVertical = _context$barDimension7.isVertical;
    var width = _context$barDimension7.width;
    var length = _context$barDimension7.length;
    var barWidth = _context$barDimension7.barWidth;
    var barOffset = _context$barDimension7.barOffset;
    var barMargin = _context$barDimension7.barMargin;
    var ticksLength = _context$barDimension7.ticksLength;
    var X = _context$barDimension7.X;
    var Y = _context$barDimension7.Y;
    var ticksPadding = _context$barDimension7.ticksPadding;

    var hasLeft = options.needleSide !== 'right';
    var hasRight = options.needleSide !== 'left';
    var position = ticksLength * (options.value - options.minValue) / (options.maxValue - options.minValue);
    var tickWidth = (options.ticksWidth / 100 + ticksPadding) * width;
    var baseLength = barWidth / 2 + tickWidth;
    var needleLength = baseLength * (options.needleEnd / 100);
    var sX = void 0,
        eX = void 0,
        sY = void 0,
        eY = void 0;
    var draw = options.needleType.toLowerCase() === 'arrow' ? drawLinearArrowNeedle : drawLinearLineNeedle;
    var barStart = (width - barWidth) / 2;
    var needleStart = baseLength * (options.needleStart / 100);
    var nLeft = barStart - tickWidth - needleStart;
    var nRight = barStart + barWidth + tickWidth + needleStart;

    context.save();

    drawings.drawNeedleShadow(context, options);

    if (isVertical) {
        sY = round(Y + length - barMargin - barOffset - position);

        if (hasLeft) {
            sX = round(X + nLeft);
            eX = sX + needleLength;
            draw(context, options, sX, sY, eX, sY, needleLength);
        }

        if (hasRight) {
            sX = round(X + nRight);
            eX = sX - needleLength;
            draw(context, options, sX, sY, eX, sY, needleLength, true);
        }
    } else {
        sX = round(X + barMargin + barOffset + position);

        if (hasLeft) {
            sY = round(Y + nLeft);
            eY = sY + needleLength;
            draw(context, options, sX, sY, sX, eY, needleLength);
        }

        if (hasRight) {
            sY = round(Y + nRight);
            eY = sY - needleLength;
            draw(context, options, sX, sY, sX, eY, needleLength, true);
        }
    }

    context.restore();
}

/* istanbul ignore next: private, not testable */
/**
 * Returns needle color style
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {number} length
 * @param {boolean} [isRight]
 * @return {CanvasGradient|string}
 */
function needleStyle(context, options, length, isRight) {
    return options.colorNeedleEnd ? drawings.linearGradient(context, isRight ? options.colorNeedleEnd : options.colorNeedle, isRight ? options.colorNeedle : options.colorNeedleEnd, length, !context.barDimensions.isVertical) : options.colorNeedle;
}

/* istanbul ignore next: private, not testable */
/**
 * Draws line needle shape
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {number} sX
 * @param {number} sY
 * @param {number} eX
 * @param {number} eY
 * @param {number} length
 * @param {boolean} [isRight]
 */
function drawLinearLineNeedle(context, options, sX, sY, eX, eY, length, isRight) {
    context.lineWidth = options.needleWidth;
    context.strokeStyle = needleStyle(context, options, length, isRight);

    context.beginPath();
    context.moveTo(sX, sY);
    context.lineTo(eX, eY);
    context.stroke();
    context.closePath();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws arrow needle shape
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {number} sX
 * @param {number} sY
 * @param {number} eX
 * @param {number} eY
 * @param {number} length
 * @param {boolean} [isRight]
 */
function drawLinearArrowNeedle(context, options, sX, sY, eX, eY, length, isRight) {
    var peakLength = round(length * .4);
    var bodyLength = length - peakLength;
    var isVertical = sX === eX;
    var halfWidth = options.needleWidth / 2;

    context.fillStyle = needleStyle(context, options, length, isRight);

    context.beginPath();

    if (isVertical) {
        if (sY > eY) bodyLength *= -1;

        context.moveTo(sX - halfWidth, sY);
        context.lineTo(sX + halfWidth, sY);
        context.lineTo(sX + halfWidth, sY + bodyLength);
        context.lineTo(sX, eY);
        context.lineTo(sX - halfWidth, sY + bodyLength);
        context.lineTo(sX - halfWidth, sY);
    } else {
        if (sX > eX) bodyLength *= -1;

        context.moveTo(sX, sY - halfWidth);
        context.lineTo(sX, sY + halfWidth);
        context.lineTo(sX + bodyLength, sY + halfWidth);
        context.lineTo(eX, sY);
        context.lineTo(sX + bodyLength, sY - halfWidth);
        context.lineTo(sX, sY - halfWidth);
    }

    context.fill();
    context.closePath();
}

/* istanbul ignore next: private, not testable */
/**
 * Draws value box for linear gauge
 *
 * @access private
 * @param {Canvas2DContext} context
 * @param {LinearGaugeOptions} options
 * @param {number} value
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 */
function drawLinearValueBox(context, options, value, x, y, w, h) {
    // currently value box is available only for vertical linear gauge,
    // as far as by design it is hard to find a proper place for
    // horizontal ones
    context.barDimensions.isVertical && drawings.drawValueBox(context, options, value, x + w / 2, y + h - 40 * (w / 300), w);
}

/**
 * Minimalistic HTML5 Canvas Linear Gauge
 */

var LinearGauge = function (_BaseGauge2) {
    _inherits(LinearGauge, _BaseGauge2);

    /**
     * @constructor
     * @param {LinearGaugeOptions} options
     */
    function LinearGauge(options) {
        _classCallCheck(this, LinearGauge);

        options = Object.assign({}, defaultLinearGaugeOptions, options || {});

        /* istanbul ignore else */
        if (options.barStrokeWidth >= options.barWidth) {
            options.barStrokeWidth = round(options.barWidth / 2);
        }

        //noinspection JSUndefinedPropertyAssignment
        options.hasLeft = hasTicksBar('right', options);
        //noinspection JSUndefinedPropertyAssignment
        options.hasRight = hasTicksBar('left', options);

        return _possibleConstructorReturn(this, (LinearGauge.__proto__ || Object.getPrototypeOf(LinearGauge)).call(this, options));
    }

    /* istanbul ignore next */
    /**
     * Triggering linear gauge render on a canvas.
     *
     * @returns {LinearGauge}
     */


    _createClass(LinearGauge, [{
        key: 'draw',
        value: function draw() {
            try {
                var canvas = this.canvas;
                var x = -canvas.drawX;
                var y = -canvas.drawY;
                var w = canvas.drawWidth;
                var h = canvas.drawHeight;

                var options = this.options;

                if (!canvas.elementClone.initialized) {
                    var context = canvas.contextClone;

                    // clear the cache
                    context.clearRect(x, y, w, h);
                    context.save();

                    this.drawBox = drawLinearPlate(context, options, x, y, w, h);

                    drawLinearBar.apply(undefined, [context, options].concat(_toConsumableArray(this.drawBox)));

                    canvas.context.barDimensions = context.barDimensions;

                    drawLinearBarHighlights(context, options);
                    drawLinearMinorTicks(context, options);
                    drawLinearMajorTicks(context, options);
                    drawLinearMajorTicksNumbers(context, options);
                    drawLinearTitle(context, options);
                    drawLinearUnits(context, options);

                    canvas.elementClone.initialized = true;
                }

                this.canvas.commit();

                // clear the canvas
                canvas.context.clearRect(x, y, w, h);
                canvas.context.save();

                canvas.context.drawImage(canvas.elementClone, x, y, w, h);
                canvas.context.save();

                drawLinearBarProgress.apply(undefined, [canvas.context, options].concat(_toConsumableArray(this.drawBox)));
                drawLinearBarNeedle(canvas.context, options);
                drawLinearValueBox.apply(undefined, [canvas.context, options, options.animatedValue ? this.options.value : this.value].concat(_toConsumableArray(this.drawBox)));

                _get(LinearGauge.prototype.__proto__ || Object.getPrototypeOf(LinearGauge.prototype), 'draw', this).call(this);
            } catch (err) {
                drawings.verifyError(err);
            }

            return this;
        }
    }]);

    return LinearGauge;
}(BaseGauge);

/**
 * @ignore
 * @typedef {object} ns
 */
/* istanbul ignore if */


if (typeof ns !== 'undefined') {
    ns['LinearGauge'] = LinearGauge;
}

BaseGauge.initialize('LinearGauge', defaultLinearGaugeOptions);;typeof module !== "undefined" && Object.assign(ns, {Collection: Collection,GenericOptions: GenericOptions,Animation: Animation,BaseGauge: BaseGauge,drawings: drawings,SmartCanvas: SmartCanvas,vendorize: vendorize});}(typeof module !== "undefined" ? module.exports : window));